import React, {useState} from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";


import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const initialState = {
    supprimerSousCategories : false,
    supprimerCours : false,
}

function SupprimerCategorieDialog(props) {

    const [state,setState] = useState(initialState);

    const  handleChangeSousCategories = (event) => {
        const checked = event.target.checked;
        setState(prevState => {
            return {
                ...prevState,
                supprimerSousCategories: checked
            }
        })
    };

    const  handleChangeCours = (event) => {
        const checked = event.target.checked;
        setState(prevState => {
            return {
                ...prevState,
                supprimerCours: checked
            }
        })
    };

    return (<Dialog
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title" className={"text-center"}>Voulez vous vraiment supprimer la categorie ?</DialogTitle>
        <DialogContent>

            <div>
                <FormControlLabel
                    control={<Switch color={"primary"} checked={state.supprimerSousCategories} onChange={handleChangeSousCategories}/>}
                    label="supprimer les sous categories!"
                />
            </div>

            <div>
                <FormControlLabel
                    control={<Switch color={"primary"} checked={state.supprimerCours} onChange={handleChangeCours}/>}
                    label="supprimer les cours!"
                />
            </div>


        </DialogContent>
        <DialogActions className={"justify-content-center"}>
            <Button onClick={props.onClose} variant={"contained"} color={"default"}>
                Annuler
            </Button>
            <Button onClick={() => props.supprimer(state.supprimerSousCategories,state.supprimerCours)} variant={"contained"} color={"secondary"}>
                Supprimer
            </Button>
        </DialogActions>
    </Dialog>);

}

export default SupprimerCategorieDialog;